import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { FormErrorStateMatcher, FormService } from 'src/app/core/form.service';
import { OrderCreationRequirements, Store, StoresService } from 'src/app/core/stores.service';
import { StoresToggleDialogComponent } from '../stores-toggle-dialog/stores-toggle-dialog.component';
import { FormGroup } from '@angular/forms';
import { CompaniesService } from 'src/app/core/companies.service';

@Component({
  selector: 'app-stores-ticket-dialog',
  templateUrl: './stores-ticket-dialog.component.html',
  styleUrls: ['./stores-ticket-dialog.component.scss'],
})
export class StoresTicketDialogComponent {
  store?: Store;
  is_edit_running: boolean = false;
  store_order_ticket_requirements_from_group: FormGroup = this.form_service.store_order_ticket_requirements_from_group;
  error_matcher: FormErrorStateMatcher = this.form_service.matcher;

  is_company_read_running: boolean = false;
  company_min_amount: number | null = null;
  company_max_amount: number | null = null;

  constructor(
    private readonly dialog_ref: MatDialogRef<StoresToggleDialogComponent>,
    private readonly form_service: FormService,
    private readonly stores_service: StoresService,
    private readonly companies_service: CompaniesService,
    private readonly error_service: ErrorService,
    @Inject(MAT_DIALOG_DATA) data: any,
  ) {
    this.store = data.store;
  }

  ngOnInit(): void {
    if (this.store) {
      const min_amount: number = this.store.order_requirements?.min_amount || 20000;
      const max_amount: number = this.store.order_requirements?.max_amount || 200000;

      this.store_order_ticket_requirements_from_group
        .get(this.form_service.min_amount_label)
        ?.setValue(min_amount / 100);
      this.store_order_ticket_requirements_from_group
        .get(this.form_service.max_amount_label)
        ?.setValue(max_amount / 100);

      this.store_order_ticket_requirements_from_group
        .get(this.form_service.is_bnpl_long_enabled_label)
        ?.setValue(this.store?.order_requirements?.is_bnpl_long_enabled);

      this.readCompany(this.store.company_id!);
    }
  }

  readCompany(company_id: string): void {
    this.is_company_read_running = true;
    this.companies_service.readCompany(company_id).subscribe({
      next: response => {
        this.company_min_amount = response.data?.order_requirements?.min_amount / 100 || null;
        this.company_max_amount = response.data?.order_requirements?.max_amount / 100 || null;
        this.is_company_read_running = false;
      },
      error: error => {
        this.error_service.processApiError(error);
        this.is_company_read_running = false;
      },
    });
  }

  onCloseClick(): void {
    this.dialog_ref.close();
  }

  onConfirmClick(): void {
    const is_enabled = this.store?.order_requirements?.is_enabled || false;
    const is_partially_enabled = this.store?.order_requirements?.is_partially_enabled || false;
    const is_web_sale_enabled = this.store?.order_requirements?.is_web_sale_enabled || false;
    const is_in_store_sale_enabled = this.store?.order_requirements?.is_in_store_sale_enabled || false;
    const is_sdd_payment_enabled: boolean = this.store?.order_requirements?.is_sdd_payment_enabled || false;

    const order_requirements = {
      is_enabled,
      is_partially_enabled,
      is_web_sale_enabled,
      is_in_store_sale_enabled,
      is_sdd_payment_enabled,
      ...this.stores_service.buildOrderTicketRequirementsFromForm(this.store_order_ticket_requirements_from_group),
    };

    if (this.store?.store_id) {
      this.setOrderRequirements(this.store.store_id, order_requirements);
    }
  }

  setOrderRequirements(store_id: string, order_requirements: OrderCreationRequirements): void {
    this.is_edit_running = true;
    this.stores_service.setOrderRequirements(store_id, order_requirements).subscribe({
      next: () => {
        this.setBnplLong(store_id, order_requirements.is_bnpl_long_enabled || false);
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_edit_running = false;
      },
    });
  }

  setBnplLong(store_id: string, is_bnpl_long_enabled: boolean): void {
    this.is_edit_running = true;
    this.stores_service.setBnplLong(store_id, is_bnpl_long_enabled).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_edit_running = false;
      },
    });
  }
}
